// Match the established pacing of game-completion rewards.
export const RESOURCE_BEAT_SPACING_MS = 2400;
export const RESOURCE_FLIGHT_DURATION_MS = 680;
export const RESOURCE_RECEIVE_DURATION_MS = 700;
export const RESOURCE_ORDER = ['streak', 'stelline', 'learned_terms', 'gettoncini'];

// A +1 flight starts from the server's resulting streak, including restarts.
export const getStreakCounterBefore = (resultingCount) => {
  const count = Number(resultingCount);
  return Number.isFinite(count) ? Math.max(0, count - 1) : 0;
};

export const compareResourceOrder = (left, right) => (
  RESOURCE_ORDER.indexOf(left.type) - RESOURCE_ORDER.indexOf(right.type)
);
